<template>
  <div
    :class="{
      'flex space-x-4': variant === 'horizontal',
    }"
  >
    <ul class="nav nav-tabs bg-white">
      <li
        v-for="(tab, index) in tabList"
        :key="index"
        class="nav-item"
    
      >


        <label
          :for="`${_uid}${index}`"
          class="nav-item nav-link font-weight-normal"
          :class="{
          'active': index + 1 === activeTab,
          '': index + 1 !== activeTab,
          }"
        >
          <i 
            class="far mr-3"
            :class="tab.icon"
          >
          </i>
          <span v-text="tab.text"></span>
          <span v-text="tab.count" class="count ml-2"></span>
        </label>
        

        <input
          :id="`${_uid}${index}`"
          type="radio"
          :name="`${_uid}-tab`"
          :value="index + 1"
          v-model="activeTab"
          class="d-none"
        />

         
      </li>

     
    </ul>


    <template v-for="(tab, index) in tabList">
      <div
        :key="index"
        v-if="index + 1 === activeTab"
        class="bg-white p-4"
      >
        <slot :name="`tabPanel-${index + 1}`" />
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    tabList: {
      type: Array,
      required: true,
    },
    variant: {
      type: String,
      required: false,
      default: () => "vertical",
      validator: (value) => ["horizontal", "vertical"].includes(value),
    },
  },
  data() {
    return {
      activeTab: 1,
    };
  },
};
</script>

<style lang="scss" scoped>
  .nav-tabs {
      border-bottom: 1px solid #eaecf4;
      
  }

  .nav-link {
      border: 0 none;
      color: #6e707e;
      padding: 0.75rem 2rem;
      border-bottom: 2px solid transparent;
      cursor: pointer;
      .count {
          background-color: #EDEFF3;
          border-radius: 5px;
          font-weight: 300;
          font-size: 11px;
          display: inline-block;
          text-align: center;
          padding: 0px 5px;
          margin-left: 1em;
      }
      i{
          color: #6E707E;
          margin-right: 1em;
      }
  }

  .nav-link.active {
      background-color: transparent;
      border-bottom: 2px solid #2D8FFF;
      border-top: 0 none;
      border-right: 0 none;
      border-left: 0 none;
      color: #1e272e;
      font-weight: 601 !important;
      .count {
          background-color: #2D8FFF;
          color: #fff;
      }

      i{
          color: #2D8FFF ;
      }
  }

  .nav-link:hover,
  .nav-link:focus {
      border-bottom: 2px solid #2D8FFF;
      border-top: 0 none;
      border-right: 0 none;
      border-left: 0 none;
  }
</style>